import { BaseCategory, SlideBuilder } from "./BaseCategory";
import { BackgroundStyleType, HeaderPositionType, ListStyleType, TextStyleType, TrayType } from "../constants";
import { v4 as uuid } from "uuid";
import { AiGeneratedSlideType } from "../aiConstants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class TextBoxCategory extends BaseCategory {
    get name() {
        return "Text Boxes";
    }

    get type() {
        return SlideCategories.TEXT_BOX;
    }

    get icon() {
        return null;
    }

    get description() {
        return "The content should be displayed as text boxes, cards, or a grid layout (e.g., 2x2 grid, 3-column cards, feature boxes). Use this when items need visual separation or equal emphasis, not for bullet points or lists.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Write a collection of items for the slide that work well as separate text boxes or cards.
        Items should be relatively equal in importance and benefit from visual separation.`;
    }

    getModelHints() {
        return {
            slideType: "text boxes | 3-column cards | 2x2 grid | feature boxes",
        };
    }

    getPromptSchema() {
        return {
            items: [{
                text: "richtext content for the text box or card",
            }],
            conclusion: "an optional short conclusion, tagline or takeaway for the slide",
        };
    }

    getSlideModels(model, options = {}) {
        this.textDensity = options.textDensity ?? 1;
        let models = [
            this.buildTextBoxesSlide(model, options),
        ];

        return models;
    }

    getBodyText(model) {
        switch (this.textDensity) {
            case 0:
                return null;
            case 2:
                return model.longDescription || model.shortDescription;
            case 1:
            default:
                return model.shortDescription || model.longDescription;
        }
    }

    buildTextBoxesSlide(model, options = {}) {
        let builder = new SlideModelBuilder("textBoxGrid", model);
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        builder.createPrimary({
            collectionColor: "colorful",
            items: model.items.filter(o => o).map(item => ({
                id: uuid(),
                color: null,
                text: item.text.blocks ? item.text : { blocks: item.text }
            }))
        });

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }

        return builder.model;
    }
}
